// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px), only screen and (min-width: 667px) and (max-width: 900px) {
  .technology-div .TechnologySectionOne {
    padding: 60px 30px 30px;
  }
  .technology-div .TechnologySectionOne .TechnologySectionOne-head {
    padding-top: 40px;
    text-align: center;
  }
  .technology-div .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-header {
    font-size: 20px;
    margin-bottom: 20px;
  }
  .technology-div .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-sub {
    font-size: 14px;
    line-height: 1.8;
  }
  .technology-div .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-sub br {
    content: "";
  }
  .technology-div .TechnologySectionOne-Menu {
    padding-bottom: 30px;
    background: #f7ebd7;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu {
    height: auto !important;
    border-bottom: unset !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item:hover .ui.header {
    color: #ec7c45;
    border-bottom: unset;
    transition: 0.4s;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #bcbcbc;
    padding: 0.6em 0px;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
    font-size: 15px !important;
    height: auto !important;
    border-radius: 5px;
    line-height: 1;
    color: #1c2640;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu > .item.active {
    border-bottom: 2px solid #ec7c45;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu > .item.active .ui.header {
    border-bottom: none;
  }
  .technology-div .TechnologySectionOne-Menu .ui.secondary.pointing.menu > .item.active .ui.header:before {
    content: "";
    border: solid #ec7c45;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    margin-right: 10px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  .technology-div .content-wrapper {
    padding: 40px 30px 10px;
  }
  .technology-div .content-wrapper .header {
    font-size: 28px;
  }
  .technology-div .content-wrapper .section-custom {
    flex-direction: column-reverse;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-left {
    width: 100%;
    margin-top: 30px;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-left .header1 {
    font-size: 16px;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-left .header2 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-left .txt-content {
    font-size: 14px;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-right {
    width: 100%;
    margin-top: -40px;
  }
  .technology-div .content-wrapper .section-custom .content-wrapper-right .img-content {
    width: 120%;
    margin-left: -55px !important;
  }
  .technology-div .content-wrapper .section-custom-2 {
    flex-direction: column;
    margin-bottom: 80px;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-right {
    width: 100%;
    margin-top: -20px;
    margin-left: 0;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-right .header1 {
    font-size: 16px;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-right .header2 {
    font-size: 22px;
    margin-bottom: 20px;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-right .txt-content {
    font-size: 14px;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-left {
    width: 100%;
    margin-left: 0;
  }
  .technology-div .content-wrapper .section-custom-2 .content-wrapper-left .img-content {
    width: 100vw;
    margin-left: -30px;
  }
  .technology-div .SecurityCompliance-content-wrapper {
    padding: 40px 30px 40px;
  }
  .technology-div .SecurityCompliance-content-wrapper .header {
    font-size: 20px;
  }
  .technology-div .SecurityCompliance-content-wrapper .header .sub-header {
    font-size: 14px;
  }
  .technology-div .SecurityCompliance-content-wrapper .section-custom .content-wrapper-right .img-content {
    margin-left: -30px !important;
  }
  .technology-div .SecurityCompliance-content-wrapper .section-custom .content-wrapper-left {
    margin-top: -20px !important;
  }
  .technology-div .SecurityCompliance-content-wrapper .section-custom .content-wrapper-left .header3 {
    font-size: 18px !important;
    margin-bottom: 10px !important;
  }
  .technology-div .SecurityCompliance-content-wrapper .section-custom-2 .content-wrapper-right {
    margin-top: -20px !important;
  }
  .technology-div .SecurityCompliance-content-wrapper .section-custom-2 .content-wrapper-right .header3 {
    font-size: 18px !important;
    margin-bottom: 10px !important;
  }
  .technology-div .FlexibilityScale-content-wrapper .header {
    font-size: 20px;
    margin-bottom: 40px;
  }
  .technology-div .FlexibilityScale-content-wrapper .header .sub-header {
    font-size: 16px;
  }
  .technology-div .FlexibilityScale-content-wrapper .section-content .box-list, .technology-div .FlexibilityScale-content-wrapper .section-content .multi-box {
    display: block !important;
  }
  .technology-div .FlexibilityScale-content-wrapper .section-content .box-list .box, .technology-div .FlexibilityScale-content-wrapper .section-content .multi-box .box {
    width: 100% !important;
    margin-bottom: 30px;
    padding: 20px;
    min-height: auto !important;
  }
  .technology-div .FlexibilityScale-content-wrapper .section-content .box-list .box .box-header, .technology-div .FlexibilityScale-content-wrapper .section-content .multi-box .box .box-header {
    font-size: 16px;
  }
  .technology-div .FlexibilityScale-content-wrapper .section-content .box-list .box .box-content, .technology-div .FlexibilityScale-content-wrapper .section-content .multi-box .box .box-content {
    font-size: 14px;
  }
  .technology-div .FlexibilityScale-content-wrapper .content {
    margin-top: 50px;
  }
}
@media only screen and (min-width: 667px) and (max-width: 900px) {
  .TechnologySectionOne {
    padding-bottom: 50px !important;
  }
  .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-sub {
    font-size: 16px !important;
  }
  .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
    font-size: 16px !important;
  }
  .content-wrapper .section-custom .content-wrapper-left .header1 {
    font-size: 18px !important;
  }
  .content-wrapper .section-custom .content-wrapper-left .header2 {
    font-size: 25px !important;
  }
  .content-wrapper .section-custom .content-wrapper-left .txt-content {
    font-size: 16px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .header1 {
    font-size: 18px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .header2 {
    font-size: 25px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .txt-content {
    font-size: 16px !important;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px), only screen and (min-width: 1024px) and (max-width: 1280px) {
  .TechnologySectionOne {
    padding: 90px 30px 60px;
  }
  .TechnologySectionOne .TechnologySectionOne-head {
    padding-top: 40px;
    text-align: center;
  }
  .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-header {
    font-size: 32px;
    margin-bottom: 20px;
  }
  .TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-sub {
    font-size: 16px;
    line-height: 1.8;
  }
  .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item {
    margin: 0 20px;
  }
  .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {
    font-size: 18px;
  }
  .content-wrapper {
    padding: 100px 60px;
  }
  .content-wrapper .header {
    font-size: 32px;
  }
  .content-wrapper .section-custom {
    align-items: center;
  }
  .content-wrapper .section-custom .content-wrapper-left .header1 {
    font-size: 18px !important;
  }
  .content-wrapper .section-custom .content-wrapper-left .header2 {
    font-size: 25px !important;
  }
  .content-wrapper .section-custom .content-wrapper-left .txt-content {
    font-size: 16px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .header1 {
    font-size: 18px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .header2 {
    font-size: 25px !important;
  }
  .content-wrapper .section-custom-2 .content-wrapper-right .txt-content {
    font-size: 16px !important;
  }
  .content-wrapper .section-custom .content-wrapper-right img {
    width: 110%;
    margin-top: 10%;
    margin-left: 0;
  }
  .content-wrapper .section-custom-2 {
    align-items: center;
  }
  .content-wrapper .section-custom-2 .content-wrapper-left img {
    width: 110%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item {
    margin: 0 50px;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1319px) {
  .TechnologySectionOne-Menu .ui.secondary.pointing.menu .item {
    margin: 0 80px;
  }
}
@media only screen and (min-width: 1281px) and (max-width: 1482px) {
  .content-wrapper {
    padding: 100px 120px;
  }
  .content-wrapper .section-custom .content-wrapper-left {
    width: 45%;
  }
  .content-wrapper .section-custom .content-wrapper-right {
    width: 55%;
  }
  .content-wrapper .section-custom .content-wrapper-right img {
    width: 110%;
    margin-top: 10%;
    margin-left: 0;
  }
  .content-wrapper .section-custom-2 .content-wrapper-left {
    width: 55%;
  }
  .content-wrapper .section-custom-2 .content-wrapper-left img {
    width: 110%;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/Technology/technology.scss"],"names":[],"mappings":"AAEA,kBAAA;AAmCI;ECjCF;IACC,uBAAA;EADD;EAEC;IACC,iBAAA;IACA,kBAAA;EAAF;EACE;IACC,eAAA;IACA,mBAAA;EACH;EACE;IACC,eAAA;IACA,gBAAA;EACH;EAAG;IACC,WAAA;EAEJ;EAIA;IACC,oBAAA;IACA,mBAAA;EAFD;EAGC;IACC,uBAAA;IACG,+BAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;EADL;EAGM;IACC,cAAA;IACA,oBAAA;IACA,gBAAA;EADP;EAIE;IACC,WAAA;IACG,gBAAA;IACA,gCAAA;IACA,kBAAA;EAFN;EAGG;IACC,0BAAA;IACG,uBAAA;IACA,kBAAA;IACA,cAAA;IACA,cAAA;EADP;EAKC;IACC,gCAAA;EAHF;EAIE;IACC,mBAAA;EAFH;EAGG;IACI,WAAA;IACA,qBAAA;IACA,yBAAA;IACA,qBAAA;IACA,YAAA;IACA,kBAAA;IACH,yBAAA;IACA,iCAAA;EADJ;EAOA;IACC,uBAAA;EALD;EAMC;IACC,eAAA;EAJF;EAMC;IACC,8BAAA;EAJF;EAKE;IACC,WAAA;IACA,gBAAA;EAHH;EAIG;IACC,eAAA;EAFJ;EAIG;IACC,eAAA;IACA,mBAAA;EAFJ;EAIG;IACC,eAAA;EAFJ;EAME;IACC,WAAA;IACA,iBAAA;EAJH;EAKG;IACC,WAAA;IACA,6BAAA;EAHJ;EAOC;IACC,sBAAA;IACA,mBAAA;EALF;EAME;IACC,WAAA;IACA,iBAAA;IACA,cAAA;EAJH;EAKG;IACC,eAAA;EAHJ;EAKG;IACC,eAAA;IACA,mBAAA;EAHJ;EAKG;IACC,eAAA;EAHJ;EAOE;IACC,WAAA;IACA,cAAA;EALH;EAMG;IACC,YAAA;IACA,kBAAA;EAJJ;EAUA;IACC,uBAAA;EARD;EASC;IACC,eAAA;EAPF;EAQE;IACC,eAAA;EANH;EAWG;IACC,6BAAA;EATJ;EAYE;IACC,4BAAA;EAVH;EAWG;IACC,0BAAA;IACA,8BAAA;EATJ;EAcE;IACC,4BAAA;EAZH;EAaG;IACC,0BAAA;IACA,8BAAA;EAXJ;EAkBC;IACC,eAAA;IACA,mBAAA;EAhBF;EAiBE;IACC,eAAA;EAfH;EAmBE;IACC,yBAAA;EAjBH;EAkBG;IACC,sBAAA;IACA,mBAAA;IACA,aAAA;IACI,2BAAA;EAhBR;EAiBI;IACC,eAAA;EAfL;EAiBI;IACC,eAAA;EAfL;EAqBC;IACC,gBAAA;EAnBF;AACF;AD3II;ECqKH;IAAuB,+BAAA;EAtBtB;EAuBD;IACC,0BAAA;EArBA;EAwBD;IACC,0BAAA;EAtBA;EA0BA;IAAW,0BAAA;EAvBX;EAwBA;IAAW,0BAAA;EArBX;EAsBA;IAAe,0BAAA;EAnBf;EAsBA;IAAW,0BAAA;EAnBX;EAoBA;IAAW,0BAAA;EAjBX;EAkBA;IAAe,0BAAA;EAff;AACF;ADxKI;EC2LH;IACC,uBAAA;EAhBA;EAiBA;IACC,iBAAA;IACA,kBAAA;EAfD;EAgBC;IACC,eAAA;IACA,mBAAA;EAdF;EAgBC;IACC,eAAA;IACA,gBAAA;EAdF;EAqBC;IACC,cAAA;EAnBF;EAoBE;IACC,eAAA;EAlBH;EAwBD;IACC,mBAAA;EAtBA;EAuBA;IACC,eAAA;EArBD;EAuBA;IACC,mBAAA;EArBD;EAyBA;IAAW,0BAAA;EAtBX;EAuBA;IAAW,0BAAA;EApBX;EAqBA;IAAe,0BAAA;EAlBf;EAqBA;IAAW,0BAAA;EAlBX;EAmBA;IAAW,0BAAA;EAhBX;EAiBA;IAAe,0BAAA;EAdf;EAgBD;IACC,WAAA;IACA,eAAA;IACA,cAAA;EAdA;EAgBD;IACC,mBAAA;EAdA;EAgBD;IACC,WAAA;EAdA;AACF;ADrOI;ECyPD;IACC,cAAA;EAjBF;AACF;AAsBA;EAGG;IACC,cAAA;EAtBF;AACF;AD/OI;EC2QH;IACC,oBAAA;EAzBA;EA2BD;IACC,UAAA;EAzBA;EA2BD;IACC,UAAA;EAzBA;EA0BA;IACC,WAAA;IACA,eAAA;IACA,cAAA;EAxBD;EA4BD;IACC,UAAA;EA1BA;EA2BA;IACC,WAAA;EAzBD;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../media-queries.scss';\n\n@include devices(xs eReaders mobile miniTab) {\n\t.technology-div{\n\t\t.TechnologySectionOne {\n\t\t\tpadding: 60px 30px 30px;\n\t\t\t.TechnologySectionOne-head {\n\t\t\t\tpadding-top: 40px;\n\t\t\t\ttext-align: center;\n\t\t\t\t.TechnologySectionOne-header {\n\t\t\t\t\tfont-size: 20px;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t}\n\t\t\t\t.TechnologySectionOne-sub {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\tbr {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.TechnologySectionOne-Menu {\n\t\t\tpadding-bottom: 30px;\n\t\t\tbackground: #f7ebd7;\n\t\t\t.ui.secondary.pointing.menu{\n\t\t\t\theight: auto !important;\n\t\t\t    border-bottom: unset !important;\n\t\t\t    display: flex;\n\t\t\t    flex-direction: column;\n\t\t\t    justify-content: center;\n\t    \t\talign-items: center;\n\t\t\t    padding: 0 30px;\n\t\t\t    .item:hover{\n\t\t\t    \t.ui.header {\n\t\t\t\t\t    color: #ec7c45;\n\t\t\t\t\t    border-bottom: unset;\n\t\t\t\t\t    transition: 0.4s;\n\t\t\t\t\t}\n\t\t\t    }\n\t\t\t\t.item{\n\t\t\t\t\twidth: 100%;\n\t\t\t\t    text-align: left;\n\t\t\t\t    border-bottom: 2px solid #bcbcbc;\n\t\t\t\t    padding: 0.6em 0px;\n\t\t\t\t\t.ui.header{\n\t\t\t\t\t\tfont-size: 15px !important;\n\t\t\t\t\t    height: auto !important;\n\t\t\t\t\t    border-radius: 5px;\n\t\t\t\t\t    line-height: 1;\n\t\t\t\t\t    color: #1c2640;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.ui.secondary.pointing.menu >.item.active{\n\t\t\t\tborder-bottom: 2px solid #ec7c45;\n\t\t\t\t.ui.header {\n\t\t\t\t\tborder-bottom: none;\n\t\t\t\t\t&:before {\n\t\t\t\t\t    content: \"\";\n\t\t\t\t\t    border: solid #ec7c45;\n\t\t\t\t\t    border-width: 0 3px 3px 0;\n\t\t\t\t\t    display: inline-block;\n\t\t\t\t\t    padding: 3px;\n\t\t\t\t\t    margin-right: 10px;\n\t\t\t\t\t\ttransform: rotate(-45deg);\n\t\t\t\t\t\t-webkit-transform: rotate(-45deg);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.content-wrapper {\n\t\t\tpadding: 40px 30px 10px;\n\t\t\t.header {\n\t\t\t\tfont-size: 28px;\n\t\t\t}\n\t\t\t.section-custom {\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-top: 30px;\n\t\t\t\t\t.header1 {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t\t.header2 {\n\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t}\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-top: -40px;\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 120%;\n\t\t\t\t\t\tmargin-left: -55px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-2 {\n\t\t\t\tflex-direction: column;\n\t\t\t\tmargin-bottom: 80px;\n\t\t\t\t.content-wrapper-right {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-top: -20px;\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t.header1 {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t\t.header2 {\n\t\t\t\t\t\tfont-size: 22px;\n\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t}\n\t\t\t\t\t.txt-content {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t\t.content-wrapper-left {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t.img-content {\n\t\t\t\t\t\twidth: 100vw;\n\t\t\t\t\t\tmargin-left: -30px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.SecurityCompliance-content-wrapper{\n\t\t\tpadding: 40px 30px 40px;\n\t\t\t.header{\n\t\t\t\tfont-size: 20px;\n\t\t\t\t.sub-header{\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom{\n\t\t\t\t.content-wrapper-right{\n\t\t\t\t\t.img-content{\n\t\t\t\t\t\tmargin-left: -30px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.content-wrapper-left{\n\t\t\t\t\tmargin-top: -20px !important;\n\t\t\t\t\t.header3{\n\t\t\t\t\t\tfont-size: 18px !important;\n\t\t\t\t\t\tmargin-bottom: 10px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-custom-2{\n\t\t\t\t.content-wrapper-right{\n\t\t\t\t\tmargin-top: -20px !important;\n\t\t\t\t\t.header3{\n\t\t\t\t\t\tfont-size: 18px !important;\n\t\t\t\t\t\tmargin-bottom: 10px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\t\t.FlexibilityScale-content-wrapper{\n\t\t\t.header{\n\t\t\t\tfont-size: 20px;\n\t\t\t\tmargin-bottom: 40px;\n\t\t\t\t.sub-header{\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.section-content{\n\t\t\t\t.box-list,.multi-box{\n\t\t\t\t\tdisplay: block !important;\n\t\t\t\t\t.box{\n\t\t\t\t\t\twidth: 100% !important;\n\t\t\t\t\t\tmargin-bottom: 30px;\n\t\t\t\t\t\tpadding: 20px;\n\t   \t \t\t\t\tmin-height: auto !important;\n\t\t\t\t\t\t.box-header{\n\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.box-content{\n\t\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t.content{\n\t\t\t\tmargin-top: 50px;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n\n@include devices(miniTab) {\n\t.TechnologySectionOne {padding-bottom: 50px !important;}\n\t.TechnologySectionOne .TechnologySectionOne-head .TechnologySectionOne-sub {\n\t\tfont-size: 16px !important;\n\t}\n\n\t.TechnologySectionOne-Menu .ui.secondary.pointing.menu .item .ui.header {\n\t\tfont-size: 16px !important;\n\t}\n\n\t.content-wrapper .section-custom .content-wrapper-left {\n\t\t.header1 { font-size: 18px !important; }\n\t\t.header2 { font-size: 25px !important; }\n\t\t.txt-content { font-size: 16px !important; } \n\t}\n\t.content-wrapper .section-custom-2 .content-wrapper-right {\n\t\t.header1 { font-size: 18px !important; }\n\t\t.header2 { font-size: 25px !important; }\n\t\t.txt-content { font-size: 16px !important; } \n\t}\n}\n\n@include devices(customTablet wideTablet) {\n\t.TechnologySectionOne {\n\t\tpadding: 90px 30px 60px;\n\t\t.TechnologySectionOne-head {\n\t\t\tpadding-top: 40px;\n\t\t\ttext-align: center;\n\t\t\t.TechnologySectionOne-header {\n\t\t\t\tfont-size: 32px;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t\t.TechnologySectionOne-sub {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 1.8;\n\t\t\t}\n\t\t}\n\t}\n\n\t.TechnologySectionOne-Menu {\n\t\t.ui.secondary.pointing.menu {\n\t\t\t.item {\n\t\t\t\tmargin: 0 20px;\n\t\t\t\t.ui.header {\n\t\t\t\t\tfont-size: 18px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.content-wrapper {\n\t\tpadding: 100px 60px;\n\t\t.header {\n\t\t\tfont-size: 32px;\n\t\t}\n\t\t.section-custom {\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t.content-wrapper .section-custom .content-wrapper-left {\n\t\t.header1 { font-size: 18px !important; }\n\t\t.header2 { font-size: 25px !important; }\n\t\t.txt-content { font-size: 16px !important; } \n\t}\n\t.content-wrapper .section-custom-2 .content-wrapper-right {\n\t\t.header1 { font-size: 18px !important; }\n\t\t.header2 { font-size: 25px !important; }\n\t\t.txt-content { font-size: 16px !important; } \n\t}\n\t.content-wrapper .section-custom .content-wrapper-right img {\n\t\twidth: 110%;\n\t\tmargin-top: 10%;\n\t\tmargin-left: 0;\n\t}\n\t.content-wrapper .section-custom-2 {\n\t\talign-items: center;\n\t}\n\t.content-wrapper .section-custom-2 .content-wrapper-left img {\n\t\twidth: 110%;\n\t}\n}\n\n@include devices(wideTablet) {\n\t.TechnologySectionOne-Menu {\n\t\t.ui.secondary.pointing.menu {\n\t\t\t.item {\n\t\t\t\tmargin: 0 50px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media only screen and (min-width: 1281px) and (max-width: 1319px) {\n\t.TechnologySectionOne-Menu {\n\t\t.ui.secondary.pointing.menu {\n\t\t\t.item {\n\t\t\t\tmargin: 0 80px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include devices(miniDesktop) {\n\t.content-wrapper {\n\t\tpadding: 100px 120px;\n\t}\n\t.content-wrapper .section-custom .content-wrapper-left {\n\t\twidth: 45%;\n\t}\n\t.content-wrapper .section-custom .content-wrapper-right {\n\t\twidth: 55%;\n\t\timg {\n\t\t\twidth: 110%;\n\t\t\tmargin-top: 10%;\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n\t\t\n\t.content-wrapper .section-custom-2 .content-wrapper-left {\n\t\twidth: 55%;\n\t\timg {\n\t\t\twidth: 110%;\n\t\t}\n\t}\t\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
